import React, { useState } from 'react'

function NavBar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <a href="/" className="flex items-center">
            <img src="/foundation.png" alt="Shehala Foundation" className="h-10 w-auto" />
          </a>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center gap-6">
            <a href="/" className="text-gray-700 hover:text-gray-900 font-medium relative group py-1">
              Home
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gray-800 transition-all duration-300 group-hover:w-full"></span>
            </a>
            <a href="/about" className="text-gray-700 hover:text-gray-900 font-medium relative group py-1">
              About Us
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gray-800 transition-all duration-300 group-hover:w-full"></span>
            </a>
            <a href="/projects" className="text-gray-700 hover:text-gray-900 font-medium relative group py-1">
              Our Projects
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gray-800 transition-all duration-300 group-hover:w-full"></span>
            </a>
            <a href="/gallery" className="text-gray-700 hover:text-gray-900 font-medium relative group py-1">
              Gallery
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gray-800 transition-all duration-300 group-hover:w-full"></span>
            </a>
            <a href="/covid19" className="text-gray-700 hover:text-gray-900 font-medium relative group py-1">
              COVID-19
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gray-800 transition-all duration-300 group-hover:w-full"></span>
            </a>
            <a href="/contact" className="text-gray-700 hover:text-gray-900 font-medium relative group py-1">
              Contact Us
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gray-800 transition-all duration-300 group-hover:w-full"></span>
            </a>
            <a
              href="/donate"
              className="bg-gray-800 text-white px-4 py-2 rounded-lg font-medium hover:bg-gray-700 transition duration-300"
            >
              Donate
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-gray-700"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t">
            <div className="flex flex-col gap-4">
              <a href="/" className="text-gray-700 hover:text-gray-900 font-medium">Home</a>
              <a href="/about" className="text-gray-700 hover:text-gray-900 font-medium">About Us</a>
              <a href="/projects" className="text-gray-700 hover:text-gray-900 font-medium">Our Projects</a>
              <a href="/gallery" className="text-gray-700 hover:text-gray-900 font-medium">Gallery</a>
              <a href="/covid19" className="text-gray-700 hover:text-gray-900 font-medium">COVID-19</a>
              <a href="/contact" className="text-gray-700 hover:text-gray-900 font-medium">Contact Us</a>
              <a
                href="/donate"
                className="inline-block bg-gray-800 text-white px-4 py-2 rounded-lg font-medium hover:bg-gray-700 transition duration-300 text-center"
              >
                Donate
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  )
}

export default NavBar
